import React from "react";

const LOGO_URL = "/aurora-mark.png";

/**
 * AuroraMark — Aurora "A" brand mark. Uses the user-provided PNG which
 * already contains the orange circle + cursive "A" on a cream background.
 *
 * Props:
 *  - size: tailwind size class for h-/w- (e.g. "h-11 w-11")
 *  - className: extra classes
 */
export default function AuroraMark({ size = "h-11 w-11", className = "" }) {
  return (
    <img
      data-testid="aurora-mark"
      src={LOGO_URL}
      alt="Aurora Hijab"
      className={`${size} object-contain ${className}`}
    />
  );
}
